import { planService } from '@/data/services/plan/plan-service'
import { useQuery } from '@tanstack/react-query'

export const AVAILABLE_PLANS_QUERY_KEY = 'available-plans'

export function useAvailablePlans() {
  return useQuery({
    queryKey: [AVAILABLE_PLANS_QUERY_KEY],
    queryFn: () => planService.fetchAvailablePlans(),
    staleTime: Infinity
  })
}
